export default "__VITE_ASSET__DoQm$siC__"